import axios from "axios";
import { jwtDecode } from "jwt-decode";
import setToken from "./SetToken";
import setDevKey from "./SetDevKey";
import { key } from "./Config";

/**
 * Ensure Agency JWT exists for the open panel agencyId.
 * Always remints when missing/invalid so Add Host invite works in WebView.
 */
export async function ensureAgencyToken(agencyId, { force = false } = {}) {
  const id = (agencyId || localStorage.getItem("agencyId") || "").toString().trim();
  if (!id) return "";

  if (!force) {
    const existing = (localStorage.getItem("TOKEN") || "").trim();
    if (existing) {
      try {
        const decoded = jwtDecode(existing);
        if (decoded && String(decoded._id) === String(id)) {
          setToken(existing);
          setDevKey(key);
          return existing;
        }
      } catch {
        /* remint below */
      }
    }
  }

  const res = await axios.get(
    `agency/sessionForPanel?agencyId=${encodeURIComponent(id)}`
  );
  const token = res?.data?.token;
  if (!res?.data?.status || !token) {
    throw new Error(res?.data?.message || "Could not start agency session");
  }

  try {
    jwtDecode(token);
  } catch {
    throw new Error("Invalid agency session token");
  }

  setToken(token);
  setDevKey(key);
  localStorage.setItem("TOKEN", token);
  localStorage.setItem("KEY", key);
  localStorage.setItem("agencyId", id);
  return token;
}
